import React from 'react';
import PropTypes from 'prop-types';
import { isFarmBasedPolicyType } from '@ourbranch/farm-utils';

import { Banner } from 'core/components/banner';
import { Label } from 'core/components/label';
import { getFarmPolicyRestriction } from 'common/components/farm/uw-questions-form/helpers';

import useStyles from './policy-restrictions-banner.styles';

/**
 * Surfaces a farm policy's COMMENTS OR RESTRICTIONS as a prominent banner at the top of the policy
 * screen. For migrated IMT policies the converter writes the source comments/restrictions into
 * global.farmVerification.restrictions; underwriters can also set/clear them via the Details
 * restriction section (#32405). This makes coverage caveats (e.g. "NO COVERAGE FOR THE PATIO
 * COVER…") impossible to miss. (#32036 G-06, #32068)
 *
 * Resolution (newest-segment-wins, "" = cleared) lives in the shared getFarmPolicyRestriction
 * helper so the banner and the Details section stay in lock-step.
 */

const PolicyRestrictionsBanner = ({ policy }) => {
  const classes = useStyles();

  if (!isFarmBasedPolicyType(policy?.policyType)) {
    return null;
  }
  const restrictions = getFarmPolicyRestriction(policy);
  if (!restrictions) {
    return null;
  }

  return (
    <Banner color="orange" show iconType="alert">
      <Label type="smallWhite" className={classes.text}>
        <strong>Policy restrictions:</strong> {restrictions}
      </Label>
    </Banner>
  );
};

PolicyRestrictionsBanner.propTypes = {
  policy: PropTypes.shape({
    policyType: PropTypes.string,
    segments: PropTypes.arrayOf(PropTypes.object)
  })
};

PolicyRestrictionsBanner.defaultProps = {
  policy: undefined
};

export default PolicyRestrictionsBanner;
